import useTranslation from '@/hooks/i18n';
import { useLocation, useNavigate } from 'react-router-dom';
import Container from '../Container';
import AnimatedFadeInComponent from '../AnimatedFadeInComponent';

export interface NavigationItem {
  name: string;
  href: string;
  forceActive?: boolean;
}

function capitalizeFirstLetter(string?: string) {
  if (!string) return '';
  return string?.charAt(0)?.toUpperCase() + string?.slice(1);
}

export const NavigationSkeleton = () => {
  return (
    <Container addMargin className="!mt-sh-30">
      <div className="col-span-12">
        <div className="border-b border-people-gray-200">
          <div className="h-9 w-full animate-pulse rounded bg-gray-300" />
        </div>
      </div>
    </Container>
  );
};

function Navigation({ items }: { items: NavigationItem[]; title: string }) {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const activeItem = items.find((item) => item?.forceActive || location.pathname === item.href);
  const sectionTitle = activeItem ? capitalizeFirstLetter(t(activeItem.name?.toLowerCase())) : '';

  return (
    <AnimatedFadeInComponent>
      <Container addMargin>
        <div className="col-span-12">
          <div className="mb-sh-60 border-b border-people-gray-200">
            <nav className="flex gap-3" aria-label="Tabs">
              {items.map((item) => {
                const isActive = item?.forceActive || location.pathname === item.href;
                return (
                  <button
                    key={item?.name}
                    onClick={() => navigate(item.href)}
                    className={`h-9 px-1 pb-3 font-haffer text-sh-16-24 font-medium transition-colors ${
                      isActive ? 'border-b-2 border-dark-green text-dark-green' : 'text-people-gray-500'
                    }`}
                    aria-current={isActive ? 'page' : undefined}>
                    {capitalizeFirstLetter(t(item?.name?.toLowerCase()))}
                  </button>
                );
              })}
            </nav>
          </div>
          {sectionTitle ? (
            <h2 className="mt-sh-21 font-haffer text-sh-24 font-bold text-black-200">{sectionTitle}</h2>
          ) : null}
        </div>
      </Container>
    </AnimatedFadeInComponent>
  );
}

export default Navigation;
